module.exports = __webpack_public_path__ + "media/images/van-a8e34c7b5364649dea29898600417631.png";